// extracted by mini-css-extract-plugin
export default {"topBar":"CandidateDetailsContent_topBar__XQahM","titleBlock":"CandidateDetailsContent_titleBlock__ZnpTL","actionBar":"CandidateDetailsContent_actionBar__HRoUd"};